import coreAPI from 'apis/core';

export function getOrderMessageThreads({ orderId }) {
  if (!orderId) throw new Error('Order ID is required');

  return coreAPI.messages.getOrderMessageThreads({ orderId });
}

export function getMessagesInThread({ messageThreadId, page, limit }) {
  if (!messageThreadId) throw new Error('Message thread ID is required');

  return coreAPI.messages.getMessagesInThread({ messageThreadId, page, limit });
}

export function sendOrderMessage({ orderId, content }) {
  if (!orderId) throw new Error('Order ID is required');
  if (!content) throw new Error('Content is required');

  return coreAPI.messages.sendOrderMessage({ orderId, content });
}

export function closeOrderMessageThread({ messageThreadId }) {
  if (!messageThreadId) throw new Error('Message thread ID is required');

  return coreAPI.messages.closeOrderMessageThread({ messageThreadId });
}

export function openOrderMessageThread({ messageThreadId }) {
  if (!messageThreadId) throw new Error('Message thread ID is required');

  return coreAPI.messages.openOrderMessageThread({ messageThreadId });
}

export default {};
